class cAdminUsers {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    setUser(user) {
        this.user = user;
    }
    getUser() {
        return this.user;
    }
    onload() {
        var self = this;
        var elBtnAdd = $('#adduser');
        var elUserTable = $('#user-table');

        this.elUserSaveBtn = $("#save-user-btn");
        this.elUserSaveFrom = $("#save-user-form");
        //this.elUserAddForm = $('#user-add-form');
        //this.elUserEditForm = $('#user-edit-form');
        this.elAddUsername = $('#new-username');
        this.elAddEmail = $('#new-email');
        this.elAddPassword = $('#new-password');
        this.elAddPassword2 = $('#new-password2');
        this.elAddPermissions = $('#user-add-form input:checkbox');

        this.elEditId = $('#edit-id');
        this.elEditUsername = $('#edit-username');
        this.elEditEmail = $('#edit-email');
        this.elEditPassword = $('#edit-password');
        this.elEditPassword2 = $('#edit-password2');
        this.elEditPermissions = $('#user-edit-form input:checkbox');



        elBtnAdd.click(function () { self.onAddUsersClick(); });
        elUserTable.click(function (e) { self.userTableClickHandler(e); });
        this.elUserSaveBtn.click(function (e) { return self.saveUserFromSubmitHandler(e); });

        $("#limit").on('change', function (e) {
            var limit = $(this).val();
            var offset = $(this).data('offset');
            var orderBy = $(this).data('orderby') ?? 'date_created';
            var dir = $(this).data('dir') ?? 'desc';
            var s = $(this).data('s');
            var path = $(this).data('path') ? $(this).data('path') : '/items/listitems/';
            if (s) {
                window.location = path + '?s=' + s + '&offset=' + offset + '&limit=' + limit + '&orderBy=' + orderBy + '&dir=' + dir;
            } else {
                window.location = path + '?offset=' + offset + '&limit=' + limit + '&orderBy=' + orderBy + '&dir=' + dir;
            }
        });

        $(elUserTable).dataTable({
            'ordering': false,
            'order': [[5, 'asc']],
            'paging': false,
            'searching': false,
            'columnDefs': [
                { "orderable": false, "targets": 0 }
            ],
        });

        self.getCurrentUser();
    }
    getCurrentUser() {
        var self = this;

        $.ajax({
            url: URL_ADMIN + '/users/getcurrentuser/',
            dataType: 'json',
            type: 'post',
            success: function (response, jqXHR) {
                self.setUser(response);
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            }
        });
    }
    saveUserFromSubmitHandler(e) {
        //If it is a new user being added
        if (!$(this.elUserSaveFrom).find('*[name="user_id"]').val()) {
            if (!$(this.elUserSaveFrom).find('*[name="username"]').val()) {
                return notify.error("Username must be provided");
            } else if (!$(this.elUserSaveFrom).find('*[name="password"]').val()) {
                return notify.error("Password must be provided");
            } else if (!$(this.elUserSaveFrom).find('*[name="password2"]').val()) {
                return notify.error("Password must be confirmed");
            }
        }

        if (!$(this.elUserSaveFrom).find('*[name="email"]').val()) {
            return notify.error("Email address must be provided");
        }

        var self = this;
        var btn = $("#save-user-btn");
        var userId = $(this.elUserSaveFrom).find('*[name="user_id"]').val();
        var currentUserId = this.getUser().id;
        var previousUsername = $(this.elUserSaveFrom).find('*[name="username"]').data('username');
        var submittedUsername = $(this.elUserSaveFrom).find('*[name="username"]').val();

        $(btn).button('loading');

        $.ajax({
            url: URL_ADMIN + '/users/saveuser/',
            type: 'post',
            dataType: 'json',
            data: $(this.elUserSaveFrom).serialize(),
            success: function (response, jqXHR) {
                if (response.success) {
                    notify.success(response.message, {});

                    if (!$('#user-id').val()) {
                        setTimeout(function () {
                            window.location = URL_ADMIN + '/users/listusers/';
                        }, 2000);
                    } else if (self.getUser().id === userId && (submittedUsername != previousUsername)) {
                        notify.success("You must now reauthenticate");
                        setTimeout(function () {
                            window.location.reload();
                        }, 3000);
                    }

                } else {
                    notify.success(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            }
        });
        return false;
    }
    submitAddUser() {
        this.elUserAddForm.submit();
    }
    submitEditUser() {
        this.elUserEditForm.submit();
    }
    userTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);

        if ($(target).hasClass('edit')) {
            this.onUserEditClick(row);
        } else if ($(target).hasClass('del')) {
            this.onUserDelClick(row);
        }
    }
    onUserEditClick(row) {
        window.location = '/users/edituser/' + $(row).data('user-id');
    }
    getUserById(userId) {
        for (var i in g_users_users) {
            if (g_users_users[i].id == userId) {
                return g_users_users[i];
            }
        }
        return null;
    }
    onUserDelClick(row) {
        var userId = row.getAttribute('rel');
        if (confirm('Are you sure you want to delete this user?')) {
            this.deleteUser(userId);
        }
    }
    deleteUser(userId) {
        var form = $('<form action="' + URL_ADMIN + "/users/deleteuser" + '" method="post"><input type="hidden" name="id" value="' + userId + '"/></form>');
        $('body').append(form);
        form.submit();
    }
}
